import type {Code, CodeList} from 'services/codelists/types';
import {CodeListRef} from 'schemas/references';
import type {Metadata} from '../types';
import {getManifestationValue} from './getExpressionManifestationsValue';

type CodeLists = {
  productFormOverride?: CodeList;
  productForm?: CodeList;
  productFormDetails?: CodeList;
};

/*
Opposite version of getExpressionManifestationsBasedOnLocalCodelist.
We need two because they are used in same view.
 */
export const getExpressionManifestationsDigitalVersionLocalCodelist = (
  state: {metadataEdit: {metadata?: Pick<Metadata, 'manifestations'>}},
  expressionId: string,
  codelists: CodeLists,
): CodeList => {
  const allManifestations =
    state.metadataEdit.metadata?.manifestations.filter(
      m =>
        m.isbn &&
        m.productForm ===
          CodeListRef.PRODUCT_FORM['Digitalt format, nedlastbart (download)'],
    ) ?? [];

  const expressionManifestations = allManifestations.filter(
    m => m.expressionId === expressionId,
  );
  const otherManifestations = allManifestations.filter(
    m => m.expressionId !== expressionId,
  );
  const codes: Code[] = [
    ...expressionManifestations,
    ...otherManifestations,
  ].map(m => ({
    code: m.isbn!,
    value: getManifestationValue(m, codelists),
    deactivated: m.expressionId !== expressionId,
  }));

  return {
    id: 'expression_manifestation_digital_version',
    language: 'nb',
    codes,
  };
};
